import request from "../../Utils/curl"
import Utility from "../../Utils/utility"

let WrkAgentApiObj = {
  /**
   * wrkAgent List
   */
  async wrkAgentList (context, whereFilter = null) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      if (whereFilter) {
        postData.append("filter", JSON.stringify(whereFilter))
      }

      return await request.curl(context, "wrk_agent_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkAgentList() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkAgent View
   */
  async wrkAgentView (context, wrkAgentId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("wa_id", wrkAgentId)

      return await request.curl(context, "wrk_agent_view", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkAgentView() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkAgent Add
   */
  async wrkAgentAdd (context, wrkAgentObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in wrkAgentObj) {
        postData.append(key, wrkAgentObj[key])
      }

      return await request.curl(context, "wrk_agent_add", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkAgentAdd() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkAgent Edit
   */
  async wrkAgentEdit (context, wrkAgentObj) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      for (let key in wrkAgentObj) {
        postData.append(key, wrkAgentObj[key])
      }

      return await request.curl(context, "wrk_agent_edit", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrkAgentEdit() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkAgent Delete
   */
  async wrkAgentDelete (context, wrkAgentId) {
    try {
      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("wa_id", wrkAgentId)

      return await request.curl(context, "wrk_agent_delete", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.log("Exception occurred at wrkAgentDelete() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  },

  /**
   * wrkAgent FilterList
   */
  async wrkAgentFilterList (context, filterName = "") {
    try {
      if (!filterName) {
        return
      }

      Utility.showLoader = true
      Utility.loadingMsg = "Please wait...."

      let postData = new FormData()
      postData.append("filter_name", filterName)

      return await request.curl(context, "wrk_agent_filter_list", postData)
        .then(async response => {
          return response
        })
    }
    catch (err) {
      console.error("Exception occurred at wrk_agent_filter_list() and Exception:", err.message)
    }
    finally {
      Utility.showLoader = false
    }
  }
}

export {
  WrkAgentApiObj
}
